'use client';
import { useState, useEffect } from 'react';
import { tokensRaw } from '../../../core/tokens/tokens-raw.js';
import { prefersReducedMotion } from '../../../core/utilities/prefers-reduced-motion.js';

let getSectionElements = (e)=>e.map((e)=>document.getElementById(e)).filter((e)=>!!e).sort((e, t)=>e.getBoundingClientRect().top - t.getBoundingClientRect().top), getClickHandler = (e)=>(t)=>{
        var o;
        let i = t.target.closest('a');
        if (!i) return;
        let l = null !== (o = i.getAttribute('href')) && void 0 !== o ? o : '', c = document.querySelector(l), s = null == c ? void 0 : c.getAttribute('id');
        if (s) {
            t.preventDefault();
            let o = document.getElementById(s), { top: i } = o.getBoundingClientRect(), { height: l } = e.getBoundingClientRect(), c = parseInt(tokensRaw.SwanBaseSpace200) || 0;
            window.scrollTo({
                top: window.scrollY + i - l - c,
                behavior: prefersReducedMotion() ? 'instant' : 'smooth'
            }), o.getAttribute('tabindex') || o.setAttribute('tabindex', '-1'), o.focus({
                preventScroll: true
            });
        }
    };
function getScrollObserver(e, t, r) {
    if (!('IntersectionObserver' in window)) return ()=>{};
    let n = 0, o = 'up', i = {
        rootMargin: `${ -2 * t.getBoundingClientRect().height}px 0px`,
        threshold: 0
    }, getTargetSection = (e)=>{
        let t = r.findIndex((t)=>t == e.target);
        return t >= r.length - 1 ? e.target : r[t + 1];
    }, shouldUpdate = (e)=>'down' === o && !e.isIntersecting || 'up' === o && !!e.isIntersecting, l = new IntersectionObserver((t)=>{
        t.forEach((t)=>{
            var r;
            o = window.scrollY > n ? 'down' : 'up', n = window.scrollY;
            let i = null !== (r = ('down' === o ? getTargetSection(t) : t.target).getAttribute('id')) && void 0 !== r ? r : '';
            shouldUpdate(t) && e(i);
        });
    }, i);
    return r.forEach((e)=>{
        l.observe(e);
    }), ()=>l.disconnect();
}
function useAnchorBarIsPinned(r, n) {
    let [o, i] = useState(false);
    return useEffect(()=>{
        if (!n || !('IntersectionObserver' in window)) return;
        let e = new IntersectionObserver((e)=>{
            e.forEach((e)=>i(e.intersectionRatio < 1));
        }, {
            threshold: 1
        });
        return r.current && e.observe(r.current), ()=>e.disconnect();
    }, [
        r,
        n
    ]), [
        o
    ];
}
function useScrollOnClick(t) {
    useEffect(()=>{
        let e = t.current;
        if (!e) return;
        let r = getClickHandler(e);
        return null == e || e.addEventListener('click', r), ()=>null == e ? void 0 : e.removeEventListener('click', r);
    }, [
        t
    ]);
}
function useDestinationScrollObserver(t, r) {
    let { sticky: n, setActiveAnchor: o } = r;
    useEffect(()=>{
        let e = t.current;
        if (!e || !n) return;
        let r = getSectionElements([
            ...e.querySelectorAll('.swan-anchor-bar-list-item a[href]')
        ].map((e)=>{
            var t;
            return (null !== (t = e.getAttribute('href')) && void 0 !== t ? t : '').replace('#', '');
        })), i = getScrollObserver(o, e, r);
        return ()=>{
            i();
        };
    }, [
        n,
        t
    ]);
}
function useHorizontalItemVisibilityObserver(t, r) {
    let { pinned: n } = r;
    useEffect(()=>{
        var e;
        let r = t.current, n = null === (e = t.current) || void 0 === e ? void 0 : e.querySelector('.swan-anchor-bar-list');
        if (!r || !n) return;
        let o = [
            ...r.querySelectorAll('.swan-anchor-bar-list-item')
        ], i = o[0], l = o[o.length - 1], c = new IntersectionObserver((e)=>e.forEach((e)=>{
                let t = e.target === i ? 'swan-anchor-bar-scroll-left' : 'swan-anchor-bar-scroll-right';
                e.intersectionRatio < 1 ? r.classList.contains(t) || r.classList.add(t) : r.classList.remove(t);
            }), {
            threshold: 1,
            root: n
        });
        return c.observe(i), c.observe(l), ()=>c.disconnect();
    }, [
        t,
        n
    ]);
}
function useAnchorBarScroll(e, t) {
    useScrollOnClick(e), useDestinationScrollObserver(e, t), useHorizontalItemVisibilityObserver(e, t);
}

export { useAnchorBarIsPinned, useAnchorBarScroll };
